import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { MainClass } from '../../../../components/select/classs'
import Selectclass from './selectclass'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import CustomTable from '../../../../components/table/SimpleTable'
import { ShowLoader } from '../../../../redux/actions/loader'
import { Box, Grid } from '@mui/material';
import PrintStudentCards from './printStudentsCards'
import SuggestionInput from '../../../../components/suggestionInput/suggestionInput';
import { CustomBtn } from '../../../../components/button/button'
import { AllClasses } from '../../../../components/select/allClasses'

const StudentClassSelect = (props) => {
  const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;
  const [currentClass, setCurrentClass] = useState('')
  const [classes, setClasses] = React.useState(); // Fetch classes outside the component
  const url = useSelector((state) => state.Api);
  const dispatch = useDispatch();
  const [suggestions, setSuggestions] = useState();
  const [moveToClass, setMoveToClass] = useState(-1);
  const [disableClass, setDisableClass] = useState(-1);
  const [refreshKey, setRefreshKey] = useState(0);  // State to trigger re-render

  const CurrentClass = (getparam) => {
    //console.log(getparam)
    setCurrentClass(getparam)
  }
  //    const func = () => {

  //    }
  const ChangeOnSelect = (getparam) => {
    dispatch(ShowLoader('1'))
    setDisableClass(getparam[0])
    //console.log(getparam[1], getparam[0])
    // axios.get()
    const myfunc = async () => {
      const userToken =
        JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;
      const res = await axios.get(`${url.showClassStudents}${getparam[0]}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`
        }
      });
      if (res.status === 200) {
        const modifiedData = res.data.result.map(student => ({
          ...student,
          RollNum: student['Roll Number']
          // Optionally remove the original property
          // 'Roll Number': undefined
        }));
        setClasses(modifiedData);
        // setClasses(res.data.result)
        dispatch(ShowLoader('0'))
      }
    }
    myfunc()
  }

  function removeStudent(item, ind) {
    if (classes.includes(item)) {
      const updatedStudents = classes.filter((student, index) => index !== ind);
      setClasses(updatedStudents);
    }
  }

  function suggestionhandleInputChange(e) {
    const newValue = e.target.value;
    const record = suggestions.find(item => item.roll === newValue);

    setClasses(prevSelectedStudents => [...prevSelectedStudents, record]);
  }


  function callStudents() {
    try {
      dispatch(ShowLoader('1'))
      axios.get(url.studentCards, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      })
        .then((res) => {
          if (res.status === 200) {
            //console.log(res.data.message);
            setSuggestions(res.data.message);
            dispatch(ShowLoader('0'))
          }
        })
        .catch((err) => {
          //console.error(err); // Log the error response for debugging
        });
    } catch (err) {
      //console.error(err);
    }
  }

  const moveToClassFun = (classID) => {
    //console.log(classID)
    setMoveToClass(classID[0])
  }
  const transferStudents = () => {
    //console.log('classID', classes)
    try {
      dispatch(ShowLoader('1'))
      axios.post(url.transferStudentToNewClass, { students: classes, newClassID: moveToClass }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      })
        .then((res) => {
          if (res.status === 200) {
            //console.log(res.data.message);
            dispatch(ShowLoader('0'))
            setClasses([])
            moveToClass(-1)
          }
        })
        .catch((err) => {
          dispatch(ShowLoader('0'))

          //console.error(err); // Log the error response for debugging
        });
    } catch (err) {
      dispatch(ShowLoader('0'))
      //console.error(err);
    }
  }

  const removingClass = () => {
    //console.log(disableClass)
    try {
      dispatch(ShowLoader('1'))
      axios.post(url.disableClass, { disable: disableClass }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      })
        .then((res) => {
          if (res.status === 200) {
            dispatch(ShowLoader('0'))
            setRefreshKey(prevKey => prevKey + 1);  // Increment the key to refresh MainClass

          }
        })
        .catch((err) => {
          dispatch(ShowLoader('0'))
          //console.error(err); // Log the error response for debugging
        });
    } catch (err) {
      //console.error(err);
    }
  }
  return (
    <>
      <Grid container item >
        <Grid item xs={8} md={8} lg={8}>

          <AllClasses GetSelectedValue={(e) => ChangeOnSelect(e)} />

        </Grid>
        <Grid item mt={2} xs={4} md={4} lg={4}>
          <CustomBtn type="button" disable={disableClass === -1} lg={5} click={() => removingClass()} data="Remove Class" />
          <p>د ټولګي لرې کول به د بیا ننوتلو وروسته اغیزمن شي</p>
        </Grid>
      </Grid>
      <br />

      {
        classes && classes.length != 0 && classes != null && classes != undefined ? (
          <>
            <Grid item container>

              <Grid item lg={5} md={5}>
                <SuggestionInput
                  handleInputChange={suggestionhandleInputChange}
                  Suggestions={suggestions}
                  placeholder='Student Roll No / Name'
                  name='RollNum'
                />
              </Grid>

            </Grid>
            <Grid item container mt={2}>

              <Grid item lg={4} md={4}>
                <CustomBtn type="button" lg={5} click={() => callStudents()} data="Load Students" />
              </Grid>
            </Grid>
            <br />
            <br />
            {classes.length > 0 ?
              <Grid lg={12} item className='classes'>
                {classes.map((value, index) => (
                  <div className='printCardStd' onClick={(event) => removeStudent(value, index)} key={index}> {value.Name}  {value['RollNum']} </div>
                ))}
              </Grid>
              :
              null
            }
            <br />

            <br />
            <Grid item container>
              <Grid item lg={12}>
                <Grid item lg={3}>
                  <MainClass GetSelectedValue={(e) => moveToClassFun(e)} />
                </Grid>
                <Grid lg={2} item >
                  <p>{classes.length} متعلم تعداد</p>
                </Grid>

                <Grid item lg={3}>
                  <CustomBtn disable={moveToClass == -1} type="button" click={() => transferStudents()} data="Transfer Students" />
                </Grid>
              </Grid>

            </Grid>
          </>
        )
          :
          null
      }


    </>
  )
}

StudentClassSelect.propTypes = {}

export default StudentClassSelect